import { SetStateAction } from 'react';

export function isSetStateFunction<T>(action: SetStateAction<T>): action is (prevState: T) => T {
  return typeof action === 'function';
}
